<template>
    <hr class="context-menu-line">
</template>

<script lang="ts" setup></script>
